import { useDraggable } from '@dnd-kit/core'
import * as styles from '@/components/interAction/Drag/DragStyle.css'

export function DraggableImage({
  id,
  img,
  disabled,
  isError,
  onError,
}: {
  id: string
  img: string | null | undefined
  disabled?: boolean
  isError?: boolean
  onError?: () => void
}) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    disabled,
  })

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={styles.imageWrapper}
      style={{
        // 깜빡임 현상 제거
        transition: 'all 100.0s linear',
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.6 : 1,
        touchAction: 'none', // 모바일 터치 드래그 지원
        WebkitTouchCallout: 'none', // iOS 롱프레스 메뉴 비활성화
        userSelect: 'none', // 텍스트 선택 방지
      }}
    >
      {img && !isError ? (
        <img 
          src={img} 
          alt={id} 
          className={styles.imageSize} 
          onError={onError}
        />
      ) : (
        <div className="flex items-center justify-center w-full h-full bg-gray-100 text-gray-400 font-bold text-[10px] text-center leading-tight">
          이미지가<br/>없습니다
        </div>
      )}
    </div>
  )
}